import React from 'react';
import {
  Alert,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import AppDialog from '../common/AppDialog';

interface MovementDialogLayoutProps {
  open: boolean;
  title: string;
  hint: string;
  error: string | null;
  isLoading: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const MovementDialogLayout: React.FC<MovementDialogLayoutProps> = ({
  open,
  title,
  hint,
  error,
  isLoading,
  onClose,
  children,
}) => {
  const titleId = React.useId();
  const hintId = React.useId();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppDialog presentation="compact" contentPadding="none" closeDisabled={isLoading}
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      aria-labelledby={titleId}
      aria-describedby={hintId}
      PaperProps={{
        sx: {
          width: isMobile ? '100%' : 620,
          maxHeight: isMobile ? '100%' : 'min(92vh, 760px)',
          borderRadius: isMobile ? 0 : 3,
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle id={titleId}>{title}</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          p: 0,
          overflowY: 'auto',
        }}
      >
        <Typography id={hintId} variant="body2" color="text.secondary" sx={{ mx: { xs: 2.5, sm: 3.5 }, mt: 2.5 }}>
          {hint}
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mx: { xs: 2.5, sm: 3.5 }, mt: 2.5 }}>
            {error}
          </Alert>
        )}
        {children}
      </DialogContent>
    </AppDialog>
  );
};

export default MovementDialogLayout;
